var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 224,
    viewBox: "0 0 446 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7948_25403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3046 194.693H416.693C432.537 194.693 445.497 207.657 445.497 223.5H0.49707C0.49707 207.654 13.4571 194.693 29.3014 194.693H29.3046Z",
    fill: "#171C16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3046 194.693H269.161C285.005 194.693 297.965 207.657 297.965 223.5H0.49707C0.49707 207.654 13.4571 194.693 29.3014 194.693H29.3046Z",
    fill: "#383D40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5117 194.693H416.693C424.429 194.693 431.475 197.783 436.665 202.793C434.947 203.764 432.967 204.321 430.868 204.321H59.1467C53.3909 204.321 48.5585 200.158 47.5149 194.693H47.5117Z",
    fill: "#171C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23 154.015H337.866V158.94H383.23V154.015Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.525 43.4644C193.673 44.758 198.895 49.4611 214.034 49.2587C214.034 49.2587 215.353 49.9008 215.419 50.9572C215.353 52.0135 214.034 52.6556 214.034 52.6556C198.895 52.4532 193.673 57.1563 192.525 58.4499V52.2318L192.658 50.9572L192.525 49.6825V43.4644Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.263 58.7249C194.73 58.7249 196.741 55.2363 196.741 50.9569C196.741 46.6776 194.73 43.189 192.263 43.189C189.797 43.189 187.785 46.6808 187.785 50.9569C187.785 55.2331 189.797 58.7249 192.263 58.7249Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.991 56.8526C194.863 56.8526 196.39 54.2021 196.39 50.9539C196.39 47.7056 194.863 45.0552 192.991 45.0552C191.118 45.0552 189.591 47.7056 189.591 50.9539C189.591 54.2021 191.118 56.8526 192.991 56.8526Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.243 54.9673C195.518 54.9673 196.555 53.1644 196.555 50.9536C196.555 48.7428 195.515 46.9399 194.243 46.9399C192.972 46.9399 191.932 48.7428 191.932 50.9536C191.932 53.1644 192.972 54.9673 194.243 54.9673Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.278 199.197H100.61H100.553H96.4548H96.3979H93.3587H93.3018H91.4739C80.4841 199.197 71.5752 189.518 71.5752 177.582C71.5752 165.645 80.4841 155.967 91.4739 155.967H101.281V155.979C111.961 156.362 120.512 165.889 120.512 177.582C120.512 189.275 111.961 198.801 101.281 199.184V199.197H101.278Z",
    fill: "#171C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.288 172.116H191.549V184.281H307.288V172.116Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.315 158.94H327.484V165.769H404.315V158.94Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.641 160.866H371.763V189.749H393.641V160.866Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5 160.866H371.76V189.749H392.5V160.866Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64 160.866H365.899V163.839H400.64V160.866Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.161 159.016H289.854V164.547H373.161V159.016Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.418 202.885H361.75C350.915 202.885 342.13 192.381 342.13 179.426C342.13 166.471 350.915 155.967 361.747 155.964H371.415V202.885H371.418Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.584 202.885H363.607C352.772 202.885 343.986 192.381 343.986 179.426C343.986 166.471 352.772 155.967 363.604 155.964H364.631C353.797 155.964 345.014 166.468 345.014 179.426C345.014 192.384 353.771 202.853 364.584 202.885Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.639 202.885H366.661C355.827 202.885 347.041 192.381 347.041 179.426C347.041 166.471 355.827 155.967 366.658 155.964H367.686C356.851 155.964 348.066 166.468 348.066 179.426C348.066 192.384 356.823 202.853 367.635 202.885H367.639Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.764 202.888C381.57 202.888 390.384 192.349 390.384 179.429C390.384 166.509 381.57 155.97 370.764 155.97C359.958 155.97 351.144 166.509 351.144 179.429C351.144 192.349 359.958 202.888 370.764 202.888Z",
    fill: "#171C16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.345 195.759C378.869 195.759 385.004 188.421 385.004 179.426C385.004 170.431 378.869 163.09 371.345 163.09C363.822 163.09 357.687 170.428 357.687 179.426C357.687 188.424 363.822 195.759 371.345 195.759Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.764 193.94C377.449 193.94 382.902 187.422 382.902 179.426C382.902 171.43 377.449 164.912 370.764 164.912C364.078 164.912 358.626 171.43 358.626 179.426C358.626 187.422 364.078 193.94 370.764 193.94Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.902 179.426C382.902 187.44 377.465 193.94 370.764 193.94C364.062 193.94 358.626 187.44 358.626 179.426H382.902Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.763 187.488C374.476 187.488 377.506 183.867 377.506 179.426C377.506 174.985 374.476 171.361 370.763 171.361C367.05 171.361 364.021 174.982 364.021 179.426C364.021 183.87 367.05 187.488 370.763 187.488Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.763 185.733C373.666 185.733 376.035 182.902 376.035 179.429C376.035 175.956 373.666 173.123 370.763 173.123C367.86 173.123 365.491 175.956 365.491 179.429C365.491 182.902 367.86 185.733 370.763 185.733Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.035 179.426C376.035 182.908 373.673 185.733 370.76 185.733C367.848 185.733 365.488 182.908 365.488 179.426H376.035Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.703 179.426C381.703 180.473 380.994 181.32 380.118 181.32C379.242 181.32 378.534 180.473 378.534 179.426C378.534 178.379 379.242 177.528 380.118 177.528C380.994 177.528 381.703 178.376 381.703 179.426ZM362.993 179.426C362.993 180.473 362.285 181.324 361.409 181.32C360.533 181.32 359.824 180.473 359.824 179.426C359.824 178.379 360.533 177.528 361.409 177.528C362.285 177.528 362.993 178.376 362.993 179.426ZM370.763 166.344C371.639 166.344 372.348 167.195 372.348 168.242C372.348 169.289 371.639 170.137 370.763 170.137C369.887 170.137 369.179 169.289 369.179 168.242C369.179 167.195 369.887 166.344 370.763 166.344ZM378.499 188.677C377.879 189.417 376.877 189.417 376.257 188.677C375.637 187.937 375.637 186.735 376.257 185.995C376.877 185.255 377.879 185.255 378.499 185.995C379.119 186.735 379.119 187.937 378.499 188.677ZM365.267 172.857C364.647 173.597 363.645 173.597 363.025 172.857C362.405 172.116 362.405 170.915 363.025 170.174C363.645 169.434 364.647 169.434 365.267 170.174C365.887 170.915 365.887 172.116 365.267 172.857ZM378.499 170.178C379.119 170.918 379.119 172.12 378.499 172.86C377.879 173.6 376.877 173.6 376.257 172.86C375.637 172.12 375.637 170.918 376.257 170.178C376.877 169.438 377.879 169.438 378.499 170.178ZM370.763 188.715C371.639 188.715 372.348 189.563 372.348 190.613C372.348 191.663 371.639 192.507 370.763 192.507C369.887 192.507 369.179 191.657 369.179 190.613C369.179 189.569 369.887 188.715 370.763 188.715ZM365.267 185.995C365.887 186.735 365.887 187.937 365.267 188.677C364.647 189.417 363.645 189.417 363.025 188.677C362.405 187.937 362.405 186.735 363.025 185.995C363.645 185.255 364.647 185.255 365.267 185.995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.764 176.007C371.273 176.007 371.687 175.51 371.687 174.9C371.687 174.29 371.273 173.793 370.764 173.793C370.254 173.793 369.837 174.29 369.837 174.9C369.837 175.51 370.251 176.007 370.764 176.007Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.764 185.059C371.273 185.059 371.687 184.563 371.687 183.952C371.687 183.342 371.273 182.845 370.764 182.845C370.254 182.845 369.837 183.342 369.837 183.952C369.837 184.563 370.251 185.059 370.764 185.059Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.093 175.444C374.454 175.874 374.454 176.576 374.093 177.006C373.733 177.436 373.148 177.436 372.784 177.006C372.424 176.573 372.424 175.874 372.784 175.444C373.145 175.01 373.73 175.01 374.093 175.444Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.74 181.845C369.1 182.278 369.1 182.977 368.74 183.411C368.379 183.841 367.794 183.841 367.433 183.411C367.073 182.977 367.073 182.278 367.433 181.845C367.794 181.415 368.379 181.415 368.74 181.845Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.473 179.426C375.473 180.036 375.059 180.53 374.549 180.53C374.04 180.53 373.626 180.033 373.626 179.426C373.626 178.819 374.04 178.319 374.549 178.319C375.059 178.319 375.473 178.815 375.473 179.426Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.902 179.426C367.902 180.036 367.487 180.53 366.978 180.53C366.469 180.53 366.055 180.033 366.055 179.426C366.055 178.819 366.469 178.319 366.978 178.319C367.487 178.319 367.902 178.815 367.902 179.426Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.093 183.408C373.733 183.838 373.148 183.838 372.784 183.408C372.424 182.974 372.424 182.275 372.784 181.842C373.145 181.412 373.73 181.412 374.093 181.842C374.454 182.275 374.454 182.974 374.093 183.408Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.74 177.01C368.379 177.44 367.794 177.44 367.433 177.01C367.073 176.576 367.073 175.877 367.433 175.447C367.794 175.014 368.379 175.014 368.74 175.447C369.1 175.877 369.1 176.579 368.74 177.01Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.296 202.885H324.628C313.793 202.885 305.008 192.381 305.008 179.426C305.008 166.471 313.793 155.967 324.625 155.964H334.293V202.885H334.296Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.462 202.885H326.485C315.65 202.885 306.864 192.381 306.864 179.426C306.864 166.471 315.65 155.967 326.485 155.964H327.512C316.678 155.964 307.892 166.468 307.892 179.426C307.892 192.384 316.649 202.853 327.462 202.885Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.517 202.885H329.539C318.704 202.885 309.919 192.381 309.919 179.426C309.919 166.471 318.704 155.967 329.536 155.964H330.564C319.729 155.964 310.947 166.468 310.947 179.426C310.947 192.384 319.704 202.853 330.517 202.885Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.642 202.888C344.448 202.888 353.262 192.349 353.262 179.429C353.262 166.509 344.448 155.97 333.642 155.97C322.835 155.97 314.021 166.509 314.021 179.429C314.021 192.349 322.835 202.888 333.642 202.888Z",
    fill: "#171C16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.223 195.759C341.747 195.759 347.882 188.421 347.882 179.426C347.882 170.431 341.747 163.09 334.223 163.09C326.7 163.09 320.564 170.428 320.564 179.426C320.564 188.424 326.7 195.759 334.223 195.759Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.642 193.94C340.327 193.94 345.78 187.422 345.78 179.426C345.78 171.43 340.327 164.912 333.642 164.912C326.956 164.912 321.504 171.43 321.504 179.426C321.504 187.422 326.956 193.94 333.642 193.94Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.776 179.426C345.776 187.44 340.342 193.94 333.638 193.94C326.933 193.94 321.5 187.44 321.5 179.426H345.776Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.641 187.488C337.354 187.488 340.383 183.867 340.383 179.426C340.383 174.985 337.354 171.361 333.641 171.361C329.928 171.361 326.898 174.982 326.898 179.426C326.898 183.87 329.928 187.488 333.641 187.488Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.641 185.733C336.545 185.733 338.913 182.902 338.913 179.429C338.913 175.956 336.545 173.123 333.641 173.123C330.738 173.123 328.366 175.956 328.366 179.429C328.366 182.902 330.735 185.733 333.641 185.733Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.913 179.426C338.913 182.908 336.551 185.733 333.641 185.733C330.732 185.733 328.366 182.908 328.366 179.426H338.913Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.581 179.426C344.581 180.473 343.872 181.32 342.996 181.32C342.12 181.32 341.412 180.473 341.412 179.426C341.412 178.379 342.12 177.528 342.996 177.528C343.872 177.528 344.581 178.376 344.581 179.426ZM325.871 179.426C325.871 180.473 325.163 181.324 324.287 181.32C323.411 181.32 322.702 180.473 322.702 179.426C322.702 178.379 323.411 177.528 324.287 177.528C325.163 177.528 325.871 178.376 325.871 179.426ZM333.641 166.344C334.517 166.344 335.226 167.195 335.226 168.242C335.226 169.289 334.517 170.137 333.641 170.137C332.765 170.137 332.057 169.289 332.057 168.242C332.057 167.195 332.768 166.344 333.641 166.344ZM341.374 188.677C340.754 189.417 339.751 189.417 339.132 188.677C338.512 187.937 338.512 186.735 339.132 185.995C339.751 185.255 340.754 185.255 341.374 185.995C341.994 186.735 341.994 187.937 341.374 188.677ZM328.145 172.857C327.525 173.597 326.523 173.597 325.903 172.857C325.283 172.116 325.283 170.915 325.903 170.174C326.523 169.434 327.525 169.434 328.145 170.174C328.765 170.915 328.765 172.116 328.145 172.857ZM341.374 170.178C341.994 170.918 341.994 172.12 341.374 172.86C340.754 173.6 339.751 173.6 339.132 172.86C338.512 172.12 338.512 170.918 339.132 170.178C339.751 169.438 340.754 169.438 341.374 170.178ZM333.641 188.715C334.517 188.715 335.226 189.563 335.226 190.613C335.226 191.663 334.517 192.507 333.641 192.507C332.765 192.507 332.057 191.657 332.057 190.613C332.057 189.569 332.768 188.715 333.641 188.715ZM328.145 185.995C328.765 186.735 328.765 187.937 328.145 188.677C327.525 189.417 326.523 189.417 325.903 188.677C325.283 187.937 325.283 186.735 325.903 185.995C326.523 185.255 327.525 185.255 328.145 185.995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.641 176.007C334.15 176.007 334.565 175.51 334.565 174.9C334.565 174.29 334.15 173.793 333.641 173.793C333.132 173.793 332.718 174.29 332.718 174.9C332.718 175.51 333.132 176.007 333.641 176.007Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.641 185.059C334.15 185.059 334.565 184.563 334.565 183.952C334.565 183.342 334.15 182.845 333.641 182.845C333.132 182.845 332.718 183.342 332.718 183.952C332.718 184.563 333.132 185.059 333.641 185.059Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.968 175.444C337.329 175.874 337.329 176.576 336.968 177.006C336.608 177.436 336.02 177.436 335.659 177.006C335.299 176.573 335.299 175.874 335.659 175.444C336.02 175.01 336.608 175.01 336.968 175.444Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.618 181.845C331.978 182.278 331.978 182.977 331.618 183.411C331.257 183.841 330.672 183.841 330.308 183.411C329.948 182.977 329.948 182.278 330.308 181.845C330.669 181.415 331.254 181.415 331.618 181.845Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.351 179.426C338.351 180.036 337.937 180.53 337.424 180.53C336.912 180.53 336.501 180.033 336.501 179.426C336.501 178.819 336.915 178.319 337.424 178.319C337.934 178.319 338.351 178.815 338.351 179.426Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.78 179.426C330.78 180.036 330.365 180.53 329.856 180.53C329.347 180.53 328.933 180.033 328.933 179.426C328.933 178.819 329.347 178.319 329.856 178.319C330.365 178.319 330.78 178.815 330.78 179.426Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.968 183.408C336.608 183.838 336.02 183.838 335.659 183.408C335.299 182.974 335.299 182.275 335.659 181.842C336.02 181.412 336.608 181.412 336.968 181.842C337.329 182.275 337.329 182.974 336.968 183.408Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.618 177.01C331.257 177.44 330.672 177.44 330.308 177.01C329.948 176.576 329.948 175.877 330.308 175.447C330.669 175.014 331.254 175.014 331.618 175.447C331.978 175.877 331.978 176.579 331.618 177.01Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.127 152.554C316.5 152.554 316.874 152.567 317.24 152.592H333.1C324.536 155.458 318.252 164.861 318.252 176.016H296.507C296.507 163.061 305.292 152.554 316.127 152.554Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.502 152.554C313.875 152.554 314.249 152.567 314.615 152.592H330.476C321.911 155.458 315.627 164.861 315.627 176.016H293.882C293.882 163.061 302.667 152.554 313.502 152.554Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.357 156.935C322.889 157.377 322.437 157.845 322.003 158.333H300.606C301.08 157.839 301.574 157.371 302.086 156.935H323.357ZM320.476 160.259C319.736 161.296 319.072 162.406 318.484 163.583H296.861C297.481 162.4 298.186 161.287 298.968 160.259H320.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.987 167.261C316.111 169.978 315.627 172.929 315.627 176.016H293.882C293.882 172.92 294.385 169.965 295.295 167.261H316.987Z",
    fill: "#899299"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.151 67.4038H300.976C302.531 67.4038 303.803 68.6753 303.803 70.2314V149.572C303.803 151.124 302.531 152.399 300.976 152.399H298.151V67.4038Z",
    fill: "#0058A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.752 75.4533H164.787V13.9231C164.787 10.2005 166.311 6.80989 168.772 4.34603L168.778 4.3397L168.785 4.33338C170.796 2.32497 173.424 0.939636 176.349 0.5V6.58533C175.059 6.93957 173.908 7.62274 172.994 8.53997L172.984 8.55262C171.612 9.9253 170.758 11.8262 170.758 13.9231V75.4564L170.752 75.4533Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.817 18.9175C167.298 18.9175 167.693 19.3097 167.693 19.7936V75.4534H165.941V19.7936C165.941 19.3128 166.337 18.9175 166.817 18.9175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35 106.244H134.497V140.58H152.35V106.244Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.162 106.987H133.684V110.081H153.162V106.987Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.346 106.244H147.675V140.58H152.346V106.244Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.162 106.987H148.197V110.081H153.162V106.987Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.455 105.44H152.39C152.814 105.44 153.162 105.788 153.162 106.212V106.987H133.684V106.212C133.684 105.785 134.031 105.44 134.455 105.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.422 110.077H134.497V139.583H143.422V110.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.173 110.077H143.421V139.583H145.173V110.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.336 120.262H133.507V123.001H153.336V120.262Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35 123H134.497V123.915H152.35V123Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35 110.077H134.497V111.168H152.35V110.077Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.162 140.675H133.684V143.768H153.162V140.675Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.162 140.675H148.197V143.768H153.162V140.675Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.455 145.311H152.39C152.814 145.311 153.162 144.963 153.162 144.54V143.765H133.684V144.54C133.684 144.963 134.031 145.311 134.455 145.311Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35 139.583H134.497V140.675H152.35V139.583Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.45 92.7573H130.092C129.653 92.7573 129.292 93.1179 129.292 93.5575C129.292 93.9972 129.653 94.3577 130.092 94.3577H149.45C149.89 94.3577 150.25 93.9972 150.25 93.5575C150.25 93.1179 149.89 92.7573 149.45 92.7573Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.45 111.76H130.092C129.653 111.76 129.292 112.12 129.292 112.56C129.292 113 129.653 113.36 130.092 113.36H149.45C149.89 113.36 150.25 113 150.25 112.56C150.25 112.12 149.89 111.76 149.45 111.76Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.157 87.4976H134.137C134.867 87.4976 135.459 88.089 135.459 88.8196V114.878C135.459 115.609 134.867 116.2 134.137 116.2H127.157C126.426 116.2 125.835 115.609 125.835 114.878V88.8196C125.835 88.089 126.426 87.4976 127.157 87.4976Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.978 89.6227C128.978 89.179 128.618 88.8193 128.174 88.8193C127.731 88.8193 127.371 89.179 127.371 89.6227V113.898C127.371 114.341 127.731 114.701 128.174 114.701C128.618 114.701 128.978 114.341 128.978 113.898V89.6227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.829 84.4106H147.675V92.653H193.829V84.4106Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.816 70.1301H221.852V84.4104H147.678V77.2687C147.678 73.3404 150.891 70.127 154.819 70.127L154.816 70.1301Z",
    fill: "#007CCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.206 51.7002H269.711V70.1301H173.99V60.9136C173.99 55.8435 178.136 51.7002 183.206 51.7002Z",
    fill: "#106CC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.503 165.19H298.151V95.4297H200.479V165.19H228.503Z",
    fill: "#B40D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.151 95.4298V55.3976C298.151 53.3639 296.488 51.7002 294.454 51.7002H237.715C232.646 51.7002 228.5 55.8467 228.5 60.9136V70.127H207.618C203.69 70.127 200.477 73.3404 200.477 77.2687V84.4104V95.4266H298.151V95.4298Z",
    fill: "#0058A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2392 146.823C89.2031 146.823 90.8065 145.219 90.8065 143.255C90.8065 141.291 89.2031 139.688 87.2392 139.688C85.2753 139.688 83.6719 141.291 83.6719 143.255C83.6719 145.219 85.2753 146.823 87.2392 146.823Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3535 146.513C87.8304 146.513 89.0321 145.052 89.0321 143.258C89.0321 141.465 87.8304 140.004 86.3535 140.004C84.8766 140.004 83.6748 141.465 83.6748 143.258C83.6748 145.052 84.8766 146.513 86.3535 146.513Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5661 145.267C86.4769 145.267 87.2201 144.365 87.2201 143.255C87.2201 142.145 86.4769 141.244 85.5661 141.244C84.6553 141.244 83.9121 142.145 83.9121 143.255C83.9121 144.365 84.6553 145.267 85.5661 145.267Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2708 146.994H111.549C115.603 146.994 119.307 148.556 122.096 151.112H104.658C96.0557 151.112 89.0159 158.152 89.0159 166.755V188.161H70.6289V162.637C70.6289 154.034 77.6687 146.994 86.2708 146.994Z",
    fill: "#B40D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.436 110.077H147.675V84.4106H200.48V165.19V180.533H123.839V165.19H106.436V110.077Z",
    fill: "#B40D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.829 110.077H106.436V115.185H193.829V110.077Z",
    fill: "#EB3744"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.436 109.479L115.136 112.088L123.839 114.695V165.189H89.0322V114.695L97.7324 112.088L106.436 109.479Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.498 112.797L120.679 113.749L123.839 116.909V119.138L117.498 112.797ZM123.839 130.275L103.826 110.26L100.398 111.288L123.839 134.731V130.275ZM123.839 137.948L97.925 112.031L97.7353 112.088L89.0352 114.698V121.21L123.842 156.02V137.951L123.839 137.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.435 111.949L114.139 114.258L121.84 116.567V162.697H91.0273V116.567L98.7313 114.258L106.435 111.949Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.843 117.665V162.697H91.0273V117.665L98.7313 115.356L106.435 113.047L114.139 115.356L121.843 117.665Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.907 146.994H150.626C146.572 146.994 142.868 148.556 140.082 151.112H157.52C166.122 151.112 173.162 158.152 173.162 166.755V188.161H191.549V162.637C191.549 154.034 184.509 146.994 175.907 146.994Z",
    fill: "#E42A2A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.262 151.109H157.52C166.122 151.109 173.162 158.149 173.162 166.752V188.158H189.098V166.477C189.098 157.874 182.058 150.833 173.456 150.833H148.174C147.178 150.833 146.207 150.928 145.262 151.109Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.93 202.885H154.288C142.362 202.885 132.691 192.381 132.691 179.426C132.691 166.471 142.362 155.967 154.288 155.964H164.93V202.885Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.407 202.885H156.331C144.405 202.885 134.734 192.381 134.734 179.426C134.734 166.471 144.405 155.967 156.331 155.964H157.46C145.534 155.964 135.863 166.468 135.863 179.426C135.863 192.384 145.503 202.853 157.407 202.885Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.768 202.885H159.693C147.767 202.885 138.096 192.381 138.096 179.426C138.096 166.471 147.767 155.967 159.693 155.964H160.822C148.896 155.964 139.225 166.468 139.225 179.426C139.225 192.384 148.867 202.853 160.768 202.885Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.206 202.888C176.101 202.888 185.803 192.349 185.803 179.429C185.803 166.509 176.101 155.97 164.206 155.97C152.312 155.97 142.609 166.509 142.609 179.429C142.609 192.349 152.312 202.888 164.206 202.888Z",
    fill: "#171C16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.848 195.759C173.131 195.759 179.886 188.421 179.886 179.426C179.886 170.431 173.131 163.09 164.848 163.09C156.566 163.09 149.811 170.428 149.811 179.426C149.811 188.424 156.566 195.759 164.848 195.759Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.206 193.94C171.566 193.94 177.568 187.422 177.568 179.426C177.568 171.43 171.566 164.912 164.206 164.912C156.847 164.912 150.845 171.43 150.845 179.426C150.845 187.422 156.847 193.94 164.206 193.94Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.568 179.426C177.568 187.44 171.585 193.94 164.206 193.94C156.828 193.94 150.845 187.44 150.845 179.426H177.568Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.206 187.488C168.295 187.488 171.628 183.867 171.628 179.426C171.628 174.985 168.295 171.361 164.206 171.361C160.117 171.361 156.783 174.982 156.783 179.426C156.783 183.87 160.117 187.488 164.206 187.488Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.206 185.733C167.403 185.733 170.012 182.902 170.012 179.429C170.012 175.956 167.403 173.123 164.206 173.123C161.008 173.123 158.402 175.956 158.402 179.429C158.402 182.902 161.011 185.733 164.206 185.733Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.009 179.426C170.009 182.908 167.409 185.733 164.203 185.733C160.996 185.733 158.399 182.908 158.399 179.426H170.009Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.249 179.426C176.249 180.473 175.468 181.32 174.503 181.32C173.539 181.32 172.758 180.473 172.761 179.426C172.761 178.379 173.542 177.528 174.503 177.528C175.468 177.528 176.249 178.376 176.249 179.426ZM155.655 179.426C155.655 180.473 154.873 181.324 153.909 181.32C152.944 181.32 152.163 180.473 152.163 179.426C152.163 178.379 152.944 177.528 153.909 177.528C154.873 177.528 155.655 178.376 155.655 179.426ZM164.206 166.344C165.171 166.344 165.952 167.195 165.952 168.242C165.952 169.289 165.171 170.137 164.206 170.137C163.241 170.137 162.46 169.289 162.46 168.242C162.46 167.195 163.241 166.344 164.206 166.344ZM172.723 188.677C172.043 189.417 170.936 189.417 170.256 188.677C169.573 187.937 169.573 186.735 170.256 185.995C170.936 185.255 172.043 185.255 172.723 185.995C173.403 186.735 173.403 187.937 172.723 188.677ZM158.159 172.857C157.476 173.597 156.372 173.597 155.689 172.857C155.009 172.116 155.009 170.915 155.689 170.174C156.372 169.434 157.476 169.434 158.159 170.174C158.842 170.915 158.842 172.116 158.159 172.857ZM172.723 170.178C173.403 170.918 173.403 172.12 172.723 172.86C172.043 173.6 170.936 173.6 170.256 172.86C169.573 172.12 169.573 170.918 170.256 170.178C170.936 169.438 172.043 169.438 172.723 170.178ZM164.206 188.715C165.171 188.715 165.952 189.563 165.952 190.613C165.952 191.663 165.171 192.507 164.206 192.507C163.241 192.507 162.46 191.657 162.46 190.613C162.46 189.569 163.241 188.715 164.206 188.715ZM158.159 185.995C158.842 186.735 158.842 187.937 158.159 188.677C157.476 189.417 156.372 189.417 155.689 188.677C155.009 187.937 155.009 186.735 155.689 185.995C156.372 185.255 157.476 185.255 158.159 185.995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.206 176.007C164.766 176.007 165.224 175.51 165.224 174.9C165.224 174.29 164.766 173.793 164.206 173.793C163.646 173.793 163.188 174.29 163.188 174.9C163.188 175.51 163.646 176.007 164.206 176.007Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.206 185.059C164.766 185.059 165.224 184.563 165.224 183.952C165.224 183.342 164.766 182.845 164.206 182.845C163.646 182.845 163.188 183.342 163.188 183.952C163.188 184.563 163.646 185.059 164.206 185.059Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.872 175.444C168.27 175.874 168.27 176.576 167.872 177.006C167.473 177.436 166.828 177.436 166.433 177.006C166.034 176.573 166.034 175.874 166.433 175.444C166.831 175.01 167.476 175.01 167.872 175.444Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.98 181.845C162.378 182.278 162.378 182.977 161.98 183.411C161.582 183.841 160.936 183.841 160.541 183.411C160.143 182.977 160.143 182.278 160.541 181.845C160.94 181.415 161.585 181.415 161.98 181.845Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.389 179.426C169.389 180.036 168.934 180.53 168.371 180.53C167.808 180.53 167.353 180.033 167.353 179.426C167.353 178.819 167.808 178.319 168.371 178.319C168.934 178.319 169.389 178.815 169.389 179.426Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.059 179.426C161.059 180.036 160.604 180.53 160.041 180.53C159.478 180.53 159.022 180.033 159.022 179.426C159.022 178.819 159.478 178.319 160.041 178.319C160.604 178.319 161.059 178.815 161.059 179.426Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.872 183.408C167.473 183.838 166.828 183.838 166.433 183.408C166.034 182.974 166.034 182.275 166.433 181.842C166.831 181.412 167.476 181.412 167.872 181.842C168.27 182.275 168.27 182.974 167.872 183.408Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.98 177.01C161.582 177.44 160.936 177.44 160.541 177.01C160.143 176.576 160.143 175.877 160.541 175.447C160.94 175.014 161.585 175.014 161.98 175.447C162.378 175.877 162.378 176.579 161.98 177.01Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.648 146.994H175.926C179.98 146.994 183.686 148.556 186.473 151.112H169.034C160.432 151.112 153.393 158.152 153.393 166.755V188.161H135.009V162.637C135.009 154.034 142.045 146.994 150.651 146.994H150.648Z",
    fill: "#D51D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.518 165.189H62.4515V165.212C61.468 165.357 60.709 166.258 60.709 167.337V187.386C60.709 188.465 61.4712 189.363 62.4515 189.512V189.534H146.518V165.193V165.189Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.517 165.189H130.274L146.517 181.431V165.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.674 165.189H102.448L126.786 189.531H129.016L104.677 165.189H104.674ZM91.3092 165.189L115.648 189.531H111.192L86.8532 165.189H91.3092ZM83.6369 165.189L107.976 189.531H89.9082L65.5693 165.189H83.6369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7051 187.061V187.383C60.7051 188.462 61.4673 189.36 62.4476 189.509V189.531H146.514V187.061H60.7051Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.416 165.189H147.492C148.605 165.189 149.516 166.154 149.516 167.337V187.386C149.516 188.566 148.605 189.531 147.492 189.531H142.416V165.189Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 118.386H91.958V119.619H120.908V118.386Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 121.179H91.958V122.412H120.908V121.179Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 123.968H91.958V125.202H120.908V123.968Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 126.761H91.958V127.995H120.908V126.761Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 129.551H91.958V130.787H120.908V129.551Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 132.343H91.958V133.577H120.908V132.343Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 135.136H91.958V136.37H120.908V135.136Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 137.929H91.958V139.163H120.908V137.929Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 140.722H91.958V141.955H120.908V140.722Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 143.512H91.958V144.748H120.908V143.512Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 146.304H91.958V147.538H120.908V146.304Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 149.097H91.958V150.331H120.908V149.097Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 151.887H91.958V153.12H120.908V151.887Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 154.68H91.958V155.913H120.908V154.68Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.219 151.245H128.681C128.052 151.245 127.542 151.754 127.542 152.383V158.614C127.542 159.243 128.052 159.753 128.681 159.753H148.219C148.847 159.753 149.357 159.243 149.357 158.614V152.383C149.357 151.754 148.847 151.245 148.219 151.245Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 157.469H91.958V158.706H120.908V157.469Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 160.262H91.958V161.495H120.908V160.262Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22 117.2C97.4856 117.2 97.7007 117.415 97.7007 117.68V161.663C97.7007 161.929 97.4856 162.144 97.22 162.144C96.9543 162.144 96.7393 161.929 96.7393 161.663V117.68C96.7393 117.415 96.9543 117.2 97.22 117.2Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.827 117.2C102.093 117.2 102.308 117.415 102.308 117.68V161.666C102.308 161.932 102.093 162.147 101.827 162.147C101.562 162.147 101.347 161.932 101.347 161.666V117.684C101.347 117.418 101.562 117.203 101.827 117.203V117.2Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.433 117.2C106.699 117.2 106.914 117.415 106.914 117.681V161.663C106.914 161.929 106.699 162.144 106.433 162.144C106.167 162.144 105.952 161.929 105.952 161.663V117.678C105.952 117.412 106.167 117.197 106.433 117.197V117.2Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.04 117.2C111.306 117.2 111.521 117.415 111.521 117.68V161.663C111.521 161.929 111.306 162.144 111.04 162.144C110.775 162.144 110.56 161.929 110.56 161.663V117.68C110.56 117.415 110.775 117.2 111.04 117.2Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.648 117.2C115.913 117.2 116.128 117.415 116.128 117.68V161.663C116.128 161.929 115.913 162.144 115.648 162.144C115.382 162.144 115.167 161.929 115.167 161.663V117.68C115.167 117.415 115.382 117.2 115.648 117.2Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.575 151.245H146.113C146.743 151.245 147.252 151.754 147.252 152.383V158.614C147.252 159.243 146.743 159.753 146.113 159.753H126.575C125.946 159.753 125.437 159.243 125.437 158.614V152.383C125.437 151.754 125.946 151.245 126.575 151.245Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.295 152.285H126.574V158.712H132.295V152.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.346 152.285H133.399V158.712H143.346V152.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.457 152.285H144.396V158.712H146.457V152.285Z",
    fill: "#FFB81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.295 152.285H126.574V153.044H132.295V152.285Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.346 152.285H133.399V153.044H143.346V152.285Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.963 153.044H126.574V158.712H127.963V153.044Z",
    fill: "#FFB81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0936 151.245H67.5555C66.9267 151.245 66.417 151.754 66.417 152.383V158.614C66.417 159.243 66.9267 159.753 67.5555 159.753H87.0936C87.7224 159.753 88.2321 159.243 88.2321 158.614V152.383C88.2321 151.754 87.7224 151.245 87.0936 151.245Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9872 151.245H65.4491C64.8203 151.245 64.3105 151.754 64.3105 152.383V158.614C64.3105 159.243 64.8203 159.753 65.4491 159.753H84.9872C85.616 159.753 86.1257 159.243 86.1257 158.614V152.383C86.1257 151.754 85.616 151.245 84.9872 151.245Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.17 152.285H65.4521V158.712H71.17V152.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2196 152.285H72.2734V158.712H82.2196V152.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3325 152.285H83.2705V158.712H85.3325V152.285Z",
    fill: "#FFB81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.17 152.285H65.4521V153.044H71.17V152.285Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2196 152.285H72.2734V153.044H82.2196V152.285Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8405 153.044H65.4521V158.712H66.8405V153.044Z",
    fill: "#FFB81F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.759 146.823C157.723 146.823 159.326 145.219 159.326 143.255C159.326 141.291 157.723 139.688 155.759 139.688C153.795 139.688 152.191 141.291 152.191 143.255C152.191 145.219 153.795 146.823 155.759 146.823Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.873 146.513C156.35 146.513 157.552 145.052 157.552 143.258C157.552 141.465 156.35 140.004 154.873 140.004C153.396 140.004 152.194 141.465 152.194 143.258C152.194 145.052 153.396 146.513 154.873 146.513Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.997 145.267C154.908 145.267 155.651 144.365 155.651 143.255C155.651 142.145 154.908 141.244 153.997 141.244C153.086 141.244 152.343 142.145 152.343 143.255C152.343 144.365 153.086 145.267 153.997 145.267Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7441 184.913H108.478V182.396C108.478 181.01 107.346 179.878 105.961 179.878H101.262C99.8763 179.878 98.7441 181.01 98.7441 182.396V184.913Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0818 167.438H86.3942C87.0014 167.438 87.4916 167.932 87.4916 168.536V169.633C87.4916 170.241 86.9982 170.731 86.3942 170.731H80.0818C79.4746 170.731 78.9844 170.238 78.9844 169.633V168.536C78.9844 167.929 79.4777 167.438 80.0818 167.438Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.831 167.438H127.143C127.75 167.438 128.241 167.932 128.241 168.536V169.633C128.241 170.241 127.747 170.731 127.143 170.731H120.831C120.224 170.731 119.733 170.238 119.733 169.633V168.536C119.733 167.929 120.227 167.438 120.831 167.438Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.08 79.9004H200.48V88.8007H142.619C141.784 88.8007 141.101 88.1048 141.101 87.2572V81.447C141.101 80.5994 141.784 79.9036 142.619 79.9036H143.08V79.9004Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.774 79.9004H170.129L179.028 88.8007H154.674L145.774 79.9004ZM174.468 79.9004L183.367 88.8007H189.373L180.474 79.9004H174.468ZM195.486 79.9004H198.488L200.48 81.893V84.8945L195.486 79.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.288 79.9004H200.109V88.8007H211.738V84.3505C211.738 81.9025 209.736 79.9004 207.288 79.9004Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.244 90.7329H225.67C227.64 90.7329 229.237 92.3301 229.237 94.3006V129.019C229.237 130.99 227.64 132.587 225.67 132.587H208.244C206.274 132.587 204.677 130.99 204.677 129.019V94.3038C204.677 92.3333 206.274 90.7361 208.244 90.7361V90.7329Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.244 90.1099H225.669C226.821 90.1099 227.867 90.5811 228.626 91.3402C229.385 92.1025 229.857 93.1494 229.857 94.3006V129.016C229.857 130.167 229.385 131.214 228.626 131.977C227.867 132.739 226.821 133.21 225.669 133.21H208.244C207.093 133.21 206.046 132.739 205.287 131.98C204.528 131.217 204.057 130.171 204.057 129.019V94.3038C204.057 93.1525 204.528 92.1056 205.287 91.3465C206.046 90.5843 207.093 90.113 208.244 90.113V90.1099ZM225.669 91.356H208.244C207.434 91.356 206.701 91.685 206.166 92.2195C205.635 92.7572 205.303 93.491 205.303 94.3006V129.016C205.303 129.826 205.635 130.563 206.166 131.094C206.701 131.629 207.437 131.961 208.244 131.961H225.669C226.479 131.961 227.213 131.632 227.747 131.097C228.278 130.56 228.611 129.826 228.611 129.016V94.3006C228.611 93.491 228.282 92.754 227.747 92.2226C227.213 91.6881 226.476 91.356 225.669 91.356Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.682 92.6528H223.873C225.71 92.6528 227.2 94.1425 227.2 95.9802V106.642C227.2 108.48 225.71 109.969 223.873 109.969H209.682C207.845 109.969 206.355 108.48 206.355 106.642V95.9802C206.355 94.1425 207.845 92.6528 209.682 92.6528Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.722 92.6528H223.876C225.704 92.6528 227.203 94.152 227.203 95.9802V106.642C227.203 106.797 227.19 106.952 227.171 107.104L212.725 92.656L212.722 92.6528Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.719 58.3013H193.421C194.389 58.3013 195.173 59.0857 195.173 60.0535V64.9527C195.173 65.9206 194.389 66.705 193.421 66.705H178.722C177.754 66.705 176.97 65.9206 176.97 64.9527V60.0503C176.97 59.0857 177.754 58.3013 178.719 58.3013Z",
    fill: "#3D464A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.341 58.3013H187.039L194.785 66.0439C194.522 66.3697 194.146 66.6038 193.719 66.6765L185.341 58.3013ZM185.249 66.705H181.853L176.97 61.8215V60.0535C176.97 59.6012 177.144 59.19 177.425 58.8801L185.249 66.705ZM179.396 66.705L176.967 64.2759V64.9527C176.967 65.9174 177.754 66.705 178.716 66.705H179.396Z",
    fill: "#232D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.719 57.9028H193.418C194.01 57.9028 194.547 58.1464 194.936 58.5322C195.325 58.9213 195.565 59.459 195.565 60.0504V64.9528C195.565 65.5443 195.322 66.082 194.936 66.471C194.547 66.86 194.01 67.1036 193.418 67.1036H178.719C178.127 67.1036 177.59 66.8632 177.201 66.4742C176.812 66.0851 176.571 65.5474 176.571 64.956V60.0536C176.571 59.4621 176.812 58.9244 177.201 58.5386C177.59 58.1495 178.127 57.906 178.719 57.906V57.9028ZM193.418 58.6999H178.719C178.349 58.6999 178.007 58.8517 177.764 59.0952C177.52 59.3388 177.368 59.6804 177.368 60.0504V64.9528C177.368 65.3229 177.52 65.6645 177.764 65.908C178.007 66.1515 178.349 66.3034 178.719 66.3034H193.418C193.788 66.3034 194.13 66.1515 194.373 65.908C194.617 65.6645 194.769 65.3229 194.769 64.9528V60.0504C194.769 59.6804 194.614 59.3419 194.373 59.0952C194.13 58.8517 193.788 58.6999 193.418 58.6999Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.305 58.3013H217.007C217.975 58.3013 218.759 59.0857 218.759 60.0535V64.9527C218.759 65.9206 217.975 66.705 217.007 66.705H202.305C201.34 66.705 200.556 65.9206 200.556 64.9559V60.0535C200.556 59.0888 201.34 58.3044 202.305 58.3044V58.3013Z",
    fill: "#232D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.304 57.9028H217.007C217.598 57.9028 218.136 58.1464 218.525 58.5322C218.911 58.9213 219.154 59.459 219.154 60.0504V64.9528C219.154 65.5443 218.911 66.082 218.525 66.471C218.136 66.86 217.598 67.1036 217.007 67.1036H202.304C201.713 67.1036 201.175 66.8632 200.789 66.4742C200.401 66.0851 200.16 65.5474 200.16 64.956V60.0536C200.16 59.4621 200.404 58.9244 200.789 58.5386C201.178 58.1495 201.716 57.906 202.304 57.906V57.9028ZM217.007 58.6999H202.304C201.934 58.6999 201.593 58.8517 201.349 59.0952C201.106 59.3388 200.954 59.6804 200.954 60.0504V64.9528C200.954 65.3229 201.106 65.6645 201.349 65.908C201.593 66.1515 201.934 66.3034 202.304 66.3034H217.007C217.377 66.3034 217.719 66.1515 217.962 65.908C218.206 65.6645 218.357 65.3229 218.357 64.9528V60.0504C218.357 59.6804 218.202 59.3419 217.962 59.0952C217.719 58.8517 217.377 58.6999 217.007 58.6999Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.279 90.5557H192.779C194.617 90.5557 196.106 92.0454 196.106 93.883V104.545C196.106 106.383 194.617 107.872 192.779 107.872H153.279C151.442 107.872 149.952 106.383 149.952 104.545V93.883C149.952 92.0454 151.442 90.5557 153.279 90.5557Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.971 107.869H183.273L165.958 90.5527H167.656L184.971 107.869ZM174.778 107.869L157.463 90.5527H154.064L171.379 107.869H174.778ZM168.924 107.869L151.907 90.85C150.756 91.3751 149.949 92.539 149.949 93.8801V102.676L155.142 107.869H168.924Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.779 108.667H153.279C152.144 108.667 151.113 108.202 150.367 107.455C149.62 106.709 149.155 105.678 149.155 104.542V93.8802C149.155 92.7447 149.62 91.7137 150.367 90.9672C151.113 90.2208 152.144 89.7559 153.279 89.7559H192.779C193.915 89.7559 194.946 90.2208 195.692 90.9672C196.438 91.7137 196.9 92.7447 196.9 93.8802V104.542C196.9 105.678 196.435 106.709 195.692 107.455C194.946 108.202 193.915 108.667 192.779 108.667ZM153.279 107.076H192.779C193.475 107.076 194.108 106.791 194.566 106.332C195.025 105.874 195.309 105.241 195.309 104.545V93.8834C195.309 93.1875 195.025 92.555 194.566 92.0964C194.108 91.6378 193.475 91.3531 192.779 91.3531H153.279C152.583 91.3531 151.951 91.6378 151.492 92.0964C151.034 92.555 150.749 93.1875 150.749 93.8834V104.545C150.749 105.241 151.037 105.874 151.492 106.332C151.951 106.791 152.583 107.076 153.279 107.076Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.64 58.3013H279.18C280.144 58.3013 280.929 59.0857 280.929 60.0503V64.9527C280.929 65.9206 280.144 66.705 279.176 66.705H242.637C241.672 66.705 240.888 65.9206 240.888 64.9559V60.0535C240.888 59.0888 241.672 58.3044 242.637 58.3044L242.64 58.3013Z",
    fill: "#232D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.64 57.9028H279.179C279.771 57.9028 280.308 58.1464 280.697 58.5322C281.083 58.9213 281.327 59.459 281.327 60.0504V64.9528C281.327 65.5443 281.083 66.082 280.697 66.471C280.308 66.86 279.771 67.1036 279.179 67.1036H242.64C242.048 67.1036 241.511 66.8632 241.122 66.4742C240.733 66.0851 240.492 65.5474 240.492 64.956V60.0536C240.492 59.4621 240.736 58.9244 241.122 58.5386C241.511 58.1495 242.048 57.906 242.64 57.906V57.9028ZM279.179 58.6999H242.64C242.27 58.6999 241.928 58.8517 241.684 59.0952C241.441 59.3388 241.289 59.6804 241.289 60.0504V64.9528C241.289 65.3229 241.444 65.6645 241.684 65.908C241.928 66.1515 242.27 66.3034 242.64 66.3034H279.179C279.549 66.3034 279.891 66.1515 280.135 65.908C280.378 65.6645 280.533 65.3229 280.533 64.9528V60.0504C280.533 59.6804 280.378 59.3419 280.135 59.0952C279.891 58.8517 279.549 58.6999 279.179 58.6999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.28 92.7573H220.637C221.077 92.7573 221.438 93.1179 221.438 93.5575C221.438 93.9972 221.077 94.3577 220.637 94.3577H201.28C200.84 94.3577 200.479 93.9972 200.479 93.5575C200.479 93.1179 200.84 92.7573 201.28 92.7573Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.28 111.76H220.637C221.077 111.76 221.438 112.12 221.438 112.56C221.438 113 221.077 113.36 220.637 113.36H201.28C200.84 113.36 200.479 113 200.479 112.56C200.479 112.12 200.84 111.76 201.28 111.76Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.556 106.244H187.703V140.58H205.556V106.244Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.368 106.987H186.89V110.081H206.368V106.987Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.555 106.244H200.884V140.58H205.555V106.244Z",
    fill: "#ADAFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.369 106.987H201.403V110.081H206.369V106.987Z",
    fill: "#7D7F84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.661 105.44H205.596C206.02 105.44 206.368 105.788 206.368 106.212V106.987H186.89V106.212C186.89 105.785 187.238 105.44 187.661 105.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.628 110.077H187.703V139.583H196.628V110.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.38 110.077H196.631V139.583H198.38V110.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 120.262H186.713V123.001H206.542V120.262Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.556 123H187.703V123.915H205.556V123Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.556 110.077H187.703V111.168H205.556V110.077Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.368 140.675H186.89V143.768H206.368V140.675Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.369 140.675H201.403V143.768H206.369V140.675Z",
    fill: "#7D7F84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.661 145.311H205.596C206.02 145.311 206.368 144.963 206.368 144.54V143.765H186.89V144.54C186.89 144.963 187.238 145.311 187.661 145.311Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.556 139.583H187.703V140.675H205.556V139.583Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.646 87.4976H224.626C225.356 87.4976 225.948 88.089 225.948 88.8196V114.878C225.948 115.609 225.356 116.2 224.626 116.2H217.646C216.916 116.2 216.324 115.609 216.324 114.878V88.8196C216.324 88.089 216.916 87.4976 217.646 87.4976Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.596 87.4976H223.576C224.307 87.4976 224.898 88.089 224.898 88.8196V114.878C224.898 115.609 224.307 116.2 223.576 116.2H216.596C215.866 116.2 215.274 115.609 215.274 114.878V88.8196C215.274 88.089 215.866 87.4976 216.596 87.4976Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.986 127.444C223.588 127.444 225.71 125.322 225.71 122.719C225.71 120.116 223.588 117.994 220.986 117.994C218.383 117.994 216.261 120.116 216.261 122.719C216.261 125.322 218.383 127.444 220.986 127.444Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.239 127.444C222.842 127.444 224.964 125.322 224.964 122.719C224.964 120.116 222.842 117.994 220.239 117.994C217.637 117.994 215.515 120.116 215.515 122.719C215.515 125.322 217.637 127.444 220.239 127.444Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.739 114.701H219.509V121.647H220.739V114.701Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.127 88.8193C217.57 88.8193 217.931 89.1799 217.931 89.6227V113.898C217.931 114.34 217.57 114.701 217.127 114.701C216.685 114.701 216.324 114.34 216.324 113.898V89.6227C216.324 89.1799 216.685 88.8193 217.127 88.8193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.662 151.83C307.51 151.83 311.441 157.814 311.441 165.189C311.441 172.565 307.51 178.549 302.662 178.549H259.93V151.83H302.662Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.154 158.228C310.391 158.816 310.597 159.433 310.771 160.075H259.927V158.228H310.154ZM311.229 162.264C311.369 163.206 311.441 164.184 311.441 165.189C311.441 165.983 311.397 166.761 311.308 167.514H259.93V162.264H311.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.058 169.099C309.961 174.57 306.615 178.549 302.662 178.549H259.93V169.099H311.058Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.93 178.549C264.765 178.549 268.709 172.549 268.709 165.189C268.709 157.83 264.765 151.83 259.93 151.83C255.094 151.83 251.15 157.833 251.15 165.189C251.15 172.546 255.094 178.549 259.93 178.549Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.309 151.83C300.157 151.83 304.088 157.814 304.088 165.189C304.088 172.565 300.157 178.549 295.309 178.549H292.51C297.358 178.549 301.289 172.565 301.289 165.189C301.289 157.814 297.358 151.83 292.51 151.83H295.309Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.284 151.83C275.132 151.83 279.063 157.814 279.063 165.189C279.063 172.565 275.132 178.549 270.284 178.549H267.485C272.334 178.549 276.265 172.565 276.265 165.189C276.265 157.814 272.334 151.83 267.485 151.83H270.284Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.111 178.549H259.926V169.953L267.111 178.549Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.111 178.549H259.926V169.953L267.111 178.549Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.03 176.06C263.591 177.626 261.83 178.549 259.926 178.549C255.078 178.549 251.146 172.565 251.146 165.189C251.146 163.425 251.371 161.742 251.779 160.202L259.113 168.982L265.027 176.06H265.03Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.819 160.075H200.479V177.888H248.819V160.075Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.819 160.075L256.261 168.982L263.702 177.888H248.819V160.075Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.299 175.434H263.702V177.888H216.299C215.783 177.888 215.359 177.335 215.359 176.661C215.359 175.984 215.78 175.434 216.299 175.434Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.479 160.075L207.921 168.982L215.362 177.888H200.479V160.075Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.702 177.889H200.479V180.533H263.702V177.889Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.106 147.569H298.733V152.225H187.554C185.587 150.03 183.016 148.385 180.106 147.569Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.158 151.668C196.109 151.668 197.697 150.874 197.697 149.897C197.697 148.92 196.109 148.126 194.158 148.126C192.207 148.126 190.619 148.92 190.619 149.897C190.619 150.874 192.21 151.668 194.158 151.668Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.971 151.668C196.919 151.668 198.509 150.874 198.509 149.897C198.509 148.92 196.919 148.126 194.971 148.126C193.022 148.126 191.432 148.92 191.432 149.897C191.432 150.874 193.022 151.668 194.971 151.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.395 151.128C196.749 151.128 197.855 150.574 197.855 149.897C197.855 149.22 196.752 148.667 195.395 148.667C194.038 148.667 192.935 149.22 192.935 149.897C192.935 150.574 194.038 151.128 195.395 151.128Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.078 150.631C196.887 150.631 197.545 150.302 197.545 149.897C197.545 149.493 196.887 149.164 196.078 149.164C195.268 149.164 194.61 149.493 194.61 149.897C194.61 150.302 195.268 150.631 196.078 150.631Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.242 151.668C213.193 151.668 214.781 150.874 214.781 149.897C214.781 148.92 213.19 148.126 211.242 148.126C209.294 148.126 207.703 148.92 207.703 149.897C207.703 150.874 209.294 151.668 211.242 151.668Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.054 151.668C214.006 151.668 215.593 150.874 215.593 149.897C215.593 148.92 214.003 148.126 212.054 148.126C210.106 148.126 208.516 148.92 208.516 149.897C208.516 150.874 210.106 151.668 212.054 151.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.479 151.128C213.833 151.128 214.939 150.574 214.939 149.897C214.939 149.22 213.836 148.667 212.479 148.667C211.122 148.667 210.019 149.22 210.019 149.897C210.019 150.574 211.122 151.128 212.479 151.128Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.165 150.631C213.974 150.631 214.632 150.302 214.632 149.897C214.632 149.493 213.974 149.164 213.165 149.164C212.355 149.164 211.697 149.493 211.697 149.897C211.697 150.302 212.355 150.631 213.165 150.631Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.329 151.668C230.28 151.668 231.868 150.874 231.868 149.897C231.868 148.92 230.277 148.126 228.329 148.126C226.381 148.126 224.79 148.92 224.79 149.897C224.79 150.874 226.381 151.668 228.329 151.668Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.141 151.668C231.093 151.668 232.68 150.874 232.68 149.897C232.68 148.92 231.09 148.126 229.141 148.126C227.193 148.126 225.603 148.92 225.603 149.897C225.603 150.874 227.193 151.668 229.141 151.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.566 151.128C230.919 151.128 232.026 150.574 232.026 149.897C232.026 149.22 230.923 148.667 229.566 148.667C228.209 148.667 227.105 149.22 227.105 149.897C227.105 150.574 228.209 151.128 229.566 151.128Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.249 150.631C231.058 150.631 231.716 150.302 231.716 149.897C231.716 149.493 231.058 149.164 230.249 149.164C229.439 149.164 228.781 149.493 228.781 149.897C228.781 150.302 229.439 150.631 230.249 150.631Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.413 151.668C247.361 151.668 248.952 150.874 248.952 149.897C248.952 148.92 247.361 148.126 245.413 148.126C243.465 148.126 241.874 148.92 241.874 149.897C241.874 150.874 243.465 151.668 245.413 151.668Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.225 151.668C248.177 151.668 249.764 150.874 249.764 149.897C249.764 148.92 248.174 148.126 246.225 148.126C244.277 148.126 242.687 148.92 242.687 149.897C242.687 150.874 244.277 151.668 246.225 151.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.65 151.128C248.003 151.128 249.11 150.574 249.11 149.897C249.11 149.22 248.007 148.667 246.65 148.667C245.293 148.667 244.189 149.22 244.189 149.897C244.189 150.574 245.293 151.128 246.65 151.128Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.336 150.631C248.145 150.631 248.803 150.302 248.803 149.897C248.803 149.493 248.145 149.164 247.336 149.164C246.526 149.164 245.868 149.493 245.868 149.897C245.868 150.302 246.526 150.631 247.336 150.631Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.5 151.668C264.451 151.668 266.039 150.874 266.039 149.897C266.039 148.92 264.451 148.126 262.5 148.126C260.549 148.126 258.961 148.92 258.961 149.897C258.961 150.874 260.552 151.668 262.5 151.668Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.312 151.668C265.26 151.668 266.851 150.874 266.851 149.897C266.851 148.92 265.26 148.126 263.312 148.126C261.364 148.126 259.773 148.92 259.773 149.897C259.773 150.874 261.364 151.668 263.312 151.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.737 151.128C265.09 151.128 266.197 150.574 266.197 149.897C266.197 149.22 265.094 148.667 263.737 148.667C262.38 148.667 261.276 149.22 261.276 149.897C261.276 150.574 262.38 151.128 263.737 151.128Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.42 150.631C265.229 150.631 265.887 150.302 265.887 149.897C265.887 149.493 265.229 149.164 264.42 149.164C263.61 149.164 262.952 149.493 262.952 149.897C262.952 150.302 263.61 150.631 264.42 150.631Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.584 151.668C281.535 151.668 283.123 150.874 283.123 149.897C283.123 148.92 281.532 148.126 279.584 148.126C277.636 148.126 276.045 148.92 276.045 149.897C276.045 150.874 277.636 151.668 279.584 151.668Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.396 151.668C282.348 151.668 283.935 150.874 283.935 149.897C283.935 148.92 282.344 148.126 280.396 148.126C278.448 148.126 276.857 148.92 276.857 149.897C276.857 150.874 278.448 151.668 280.396 151.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.821 151.128C282.174 151.128 283.281 150.574 283.281 149.897C283.281 149.22 282.178 148.667 280.821 148.667C279.464 148.667 278.36 149.22 278.36 149.897C278.36 150.574 279.464 151.128 280.821 151.128Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.506 150.631C282.316 150.631 282.974 150.302 282.974 149.897C282.974 149.493 282.316 149.164 281.506 149.164C280.697 149.164 280.039 149.493 280.039 149.897C280.039 150.302 280.697 150.631 281.506 150.631Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.578 82.2817H308.054C308.633 82.2817 309.104 82.753 309.104 83.3318C309.104 83.9106 308.633 84.3819 308.054 84.3819H294.578C294 84.3819 293.528 83.9106 293.528 83.3318C293.528 82.753 294.003 82.2817 294.578 82.2817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.578 101.36H308.054C308.633 101.36 309.104 101.832 309.104 102.41C309.104 102.989 308.633 103.46 308.054 103.46H294.578C294 103.46 293.528 102.989 293.528 102.41C293.528 101.832 294.003 101.36 294.578 101.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.206 53.4716C185.154 53.4716 186.745 52.6777 186.745 51.7004C186.745 50.7231 185.154 49.9292 183.206 49.9292C181.258 49.9292 179.667 50.7231 179.667 51.7004C179.667 52.6777 181.258 53.4716 183.206 53.4716Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.393 53.4716C184.345 53.4716 185.932 52.6777 185.932 51.7004C185.932 50.7231 184.341 49.9292 182.393 49.9292C180.445 49.9292 178.854 50.7231 178.854 51.7004C178.854 52.6777 180.445 53.4716 182.393 53.4716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.969 52.9309C183.323 52.9309 184.43 52.3806 184.43 51.7006C184.43 51.0206 183.326 50.4702 181.969 50.4702C180.613 50.4702 179.509 51.0237 179.509 51.7006C179.509 52.3774 180.613 52.9309 181.969 52.9309Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.287 52.4344C182.096 52.4344 182.754 52.1054 182.754 51.7006C182.754 51.2957 182.096 50.9668 181.287 50.9668C180.477 50.9668 179.819 51.2957 179.819 51.7006C179.819 52.1054 180.477 52.4344 181.287 52.4344Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.274 53.4716C197.222 53.4716 198.813 52.6777 198.813 51.7004C198.813 50.7231 197.222 49.9292 195.274 49.9292C193.326 49.9292 191.735 50.7231 191.735 51.7004C191.735 52.6777 193.326 53.4716 195.274 53.4716Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.462 53.4716C196.413 53.4716 198.001 52.6777 198.001 51.7004C198.001 50.7231 196.41 49.9292 194.462 49.9292C192.514 49.9292 190.923 50.7231 190.923 51.7004C190.923 52.6777 192.514 53.4716 194.462 53.4716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.038 52.9309C195.391 52.9309 196.498 52.3806 196.498 51.7006C196.498 51.0206 195.394 50.4702 194.038 50.4702C192.681 50.4702 191.577 51.0237 191.577 51.7006C191.577 52.3774 192.681 52.9309 194.038 52.9309Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.355 52.4344C194.165 52.4344 194.823 52.1054 194.823 51.7006C194.823 51.2957 194.165 50.9668 193.355 50.9668C192.546 50.9668 191.888 51.2957 191.888 51.7006C191.888 52.1054 192.546 52.4344 193.355 52.4344Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.343 53.4716C209.291 53.4716 210.881 52.6777 210.881 51.7004C210.881 50.7231 209.291 49.9292 207.343 49.9292C205.394 49.9292 203.804 50.7231 203.804 51.7004C203.804 52.6777 205.394 53.4716 207.343 53.4716Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.53 53.4716C208.481 53.4716 210.069 52.6777 210.069 51.7004C210.069 50.7231 208.478 49.9292 206.53 49.9292C204.582 49.9292 202.991 50.7231 202.991 51.7004C202.991 52.6777 204.582 53.4716 206.53 53.4716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.106 52.9309C207.46 52.9309 208.566 52.3806 208.566 51.7006C208.566 51.0206 207.463 50.4702 206.106 50.4702C204.749 50.4702 203.646 51.0237 203.646 51.7006C203.646 52.3774 204.749 52.9309 206.106 52.9309Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.42 52.4344C206.229 52.4344 206.887 52.1054 206.887 51.7006C206.887 51.2957 206.229 50.9668 205.42 50.9668C204.61 50.9668 203.952 51.2957 203.952 51.7006C203.952 52.1054 204.61 52.4344 205.42 52.4344Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.411 53.4716C221.362 53.4716 222.95 52.6777 222.95 51.7004C222.95 50.7231 221.359 49.9292 219.411 49.9292C217.463 49.9292 215.872 50.7231 215.872 51.7004C215.872 52.6777 217.463 53.4716 219.411 53.4716Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.598 53.4716C220.55 53.4716 222.137 52.6777 222.137 51.7004C222.137 50.7231 220.547 49.9292 218.598 49.9292C216.65 49.9292 215.06 50.7231 215.06 51.7004C215.06 52.6777 216.65 53.4716 218.598 53.4716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.174 52.9309C219.528 52.9309 220.635 52.3806 220.635 51.7006C220.635 51.0206 219.531 50.4702 218.174 50.4702C216.818 50.4702 215.714 51.0237 215.714 51.7006C215.714 52.3774 216.818 52.9309 218.174 52.9309Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.488 52.4344C218.298 52.4344 218.955 52.1054 218.955 51.7006C218.955 51.2957 218.298 50.9668 217.488 50.9668C216.678 50.9668 216.021 51.2957 216.021 51.7006C216.021 52.1054 216.678 52.4344 217.488 52.4344Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.478 53.4716C233.426 53.4716 235.017 52.6777 235.017 51.7004C235.017 50.7231 233.426 49.9292 231.478 49.9292C229.53 49.9292 227.939 50.7231 227.939 51.7004C227.939 52.6777 229.53 53.4716 231.478 53.4716Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.666 53.4716C232.617 53.4716 234.205 52.6777 234.205 51.7004C234.205 50.7231 232.614 49.9292 230.666 49.9292C228.718 49.9292 227.127 50.7231 227.127 51.7004C227.127 52.6777 228.718 53.4716 230.666 53.4716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.242 52.9309C231.595 52.9309 232.702 52.3806 232.702 51.7006C232.702 51.0206 231.598 50.4702 230.242 50.4702C228.885 50.4702 227.781 51.0237 227.781 51.7006C227.781 52.3774 228.885 52.9309 230.242 52.9309Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.556 52.4344C230.366 52.4344 231.024 52.1054 231.024 51.7006C231.024 51.2957 230.366 50.9668 229.556 50.9668C228.747 50.9668 228.089 51.2957 228.089 51.7006C228.089 52.1054 228.747 52.4344 229.556 52.4344Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.813 80.9059C160.777 80.9059 162.381 79.3023 162.381 77.3382C162.381 75.3741 160.777 73.7705 158.813 73.7705C156.849 73.7705 155.246 75.3741 155.246 77.3382C155.246 79.3023 156.849 80.9059 158.813 80.9059Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.925 80.5931C159.402 80.5931 160.603 79.1319 160.603 77.3386C160.603 75.5452 159.402 74.084 157.925 74.084C156.448 74.084 155.246 75.5452 155.246 77.3386C155.246 79.1319 156.448 80.5931 157.925 80.5931Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.052 79.3498C157.963 79.3498 158.706 78.4484 158.706 77.3382C158.706 76.2281 157.963 75.3267 157.052 75.3267C156.142 75.3267 155.398 76.2281 155.398 77.3382C155.398 78.4484 156.142 79.3498 157.052 79.3498Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.722 80.9059C170.686 80.9059 172.289 79.3023 172.289 77.3382C172.289 75.3741 170.686 73.7705 168.722 73.7705C166.758 73.7705 165.154 75.3741 165.154 77.3382C165.154 79.3023 166.758 80.9059 168.722 80.9059Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.836 80.5931C169.313 80.5931 170.515 79.1319 170.515 77.3386C170.515 75.5452 169.313 74.084 167.836 74.084C166.359 74.084 165.157 75.5452 165.157 77.3386C165.157 79.1319 166.359 80.5931 167.836 80.5931Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.961 79.3498C167.871 79.3498 168.615 78.4484 168.615 77.3382C168.615 76.2281 167.871 75.3267 166.961 75.3267C166.05 75.3267 165.307 76.2281 165.307 77.3382C165.307 78.4484 166.05 79.3498 166.961 79.3498Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.633 80.9059C180.597 80.9059 182.2 79.3023 182.2 77.3382C182.2 75.3741 180.597 73.7705 178.633 73.7705C176.669 73.7705 175.065 75.3741 175.065 77.3382C175.065 79.3023 176.669 80.9059 178.633 80.9059Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.748 80.5931C179.225 80.5931 180.427 79.1319 180.427 77.3386C180.427 75.5452 179.225 74.084 177.748 74.084C176.271 74.084 175.069 75.5452 175.069 77.3386C175.069 79.1319 176.271 80.5931 177.748 80.5931Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.872 79.3498C177.783 79.3498 178.526 78.4484 178.526 77.3382C178.526 76.2281 177.783 75.3267 176.872 75.3267C175.961 75.3267 175.218 76.2281 175.218 77.3382C175.218 78.4484 175.961 79.3498 176.872 79.3498Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.54 22.0708H135.458V92.7574H136.54V22.0708Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.271 22.0708H214.189V92.7574H215.271V22.0708Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.076 105.428H106.03C106.432 105.428 106.758 105.754 106.758 106.155V113.784C106.758 114.186 106.432 114.511 106.03 114.511H104.076C103.674 114.511 103.349 114.186 103.349 113.784V106.155C103.349 105.754 103.674 105.428 104.076 105.428Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.831 134.099L142.333 138.906L123.839 143.717V134.099V124.478L142.333 129.288L160.831 134.099Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.233 134.099L132.536 136.36L123.839 138.622V134.099V129.576L132.536 131.838L141.233 134.099Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.109 145.219L129.974 146.813L123.839 148.408V145.219V142.025L129.974 143.622L136.109 145.219Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.607 145.22L126.723 145.969L123.839 146.719V145.22V143.717L126.723 144.467L129.607 145.22Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.002 123.193L134.92 126.075L123.839 128.956V123.193V117.431L134.92 120.312L146.002 123.193Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.259 123.193L129.051 124.55L123.839 125.904V123.193V120.486L129.051 121.84L134.259 123.193Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.915 126.679L147.833 127.697L151.752 128.716L155.67 127.697L159.589 126.679L155.67 125.657L151.752 124.639L147.833 125.657L143.915 126.679Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.439 126.679L153.595 127.156L151.752 127.637L149.908 127.156L148.067 126.679L149.908 126.198L151.752 125.72L153.595 126.198L155.439 126.679Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.688 121.315L155.404 122.02L158.124 122.728L160.844 122.02L163.563 121.315L160.844 120.606L158.124 119.901L155.404 120.606L152.688 121.315Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.682 121.315L159.405 121.647L158.124 121.979L156.846 121.647L155.568 121.315L156.846 120.983L158.124 120.647L159.405 120.983L160.682 121.315Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.352 120.088H168.756V123.915H167.352C166.777 123.915 166.309 123.447 166.309 122.871V121.135C166.309 120.559 166.777 120.091 167.352 120.091V120.088ZM169.632 120.088H178.797C179.373 120.088 179.841 120.556 179.841 121.131V122.868C179.841 123.443 179.373 123.912 178.797 123.912H169.632V120.084V120.088Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.818 78.9578L228.474 81.2097L237.13 83.4617L245.786 81.2097L254.439 78.9578L245.786 76.7058L237.13 74.457L228.474 76.7058L219.818 78.9578Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.27 78.9577L241.197 80.0173L237.13 81.0769L233.056 80.0173L228.989 78.9577L233.056 77.9014L237.13 76.8418L241.197 77.9014L245.27 78.9577Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.132 72.882L248.44 73.7391L251.748 74.6025L255.059 73.7391L258.367 72.882L255.059 72.0185L251.748 71.1582L248.44 72.0185L245.132 72.882Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.863 72.882L253.307 73.2868L251.748 73.6885L250.192 73.2868L248.636 72.882L250.192 72.4771L251.748 72.0723L253.307 72.4771L254.863 72.882Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1 75.4531H235.249V147.566H246.1V75.4531Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.07 75.4531H236.916V147.566H239.07V75.4531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 84.0339C237.779 84.0339 238.241 83.5721 238.241 83.0028C238.241 82.4335 237.779 81.9717 237.21 81.9717C236.64 81.9717 236.179 82.4335 236.179 83.0028C236.179 83.5721 236.64 84.0339 237.21 84.0339Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 84.0339C241.245 84.0339 241.707 83.5721 241.707 83.0028C241.707 82.4335 241.245 81.9717 240.676 81.9717C240.106 81.9717 239.645 82.4335 239.645 83.0028C239.645 83.5721 240.106 84.0339 240.676 84.0339Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 84.0339C244.708 84.0339 245.169 83.5721 245.169 83.0028C245.169 82.4335 244.708 81.9717 244.138 81.9717C243.569 81.9717 243.107 82.4335 243.107 83.0028C243.107 83.5721 243.572 84.0339 244.138 84.0339Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 89.1579C237.779 89.1579 238.241 88.6961 238.241 88.1268C238.241 87.5575 237.779 87.0957 237.21 87.0957C236.64 87.0957 236.179 87.5575 236.179 88.1268C236.179 88.6961 236.64 89.1579 237.21 89.1579Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 89.1579C241.245 89.1579 241.707 88.6961 241.707 88.1268C241.707 87.5575 241.245 87.0957 240.676 87.0957C240.106 87.0957 239.645 87.5575 239.645 88.1268C239.645 88.6961 240.106 89.1579 240.676 89.1579Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 89.1579C244.708 89.1579 245.169 88.6961 245.169 88.1268C245.169 87.5575 244.708 87.0957 244.138 87.0957C243.569 87.0957 243.107 87.5575 243.107 88.1268C243.107 88.6961 243.572 89.1579 244.138 89.1579Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 94.2848C237.779 94.2848 238.241 93.8231 238.241 93.2537C238.241 92.6844 237.779 92.2227 237.21 92.2227C236.64 92.2227 236.179 92.6844 236.179 93.2537C236.179 93.8231 236.64 94.2848 237.21 94.2848Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 94.2848C241.245 94.2848 241.707 93.8231 241.707 93.2537C241.707 92.6844 241.245 92.2227 240.676 92.2227C240.106 92.2227 239.645 92.6844 239.645 93.2537C239.645 93.8231 240.106 94.2848 240.676 94.2848Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 94.2848C244.708 94.2848 245.169 93.8231 245.169 93.2537C245.169 92.6844 244.708 92.2227 244.138 92.2227C243.569 92.2227 243.107 92.6844 243.107 93.2537C243.107 93.8231 243.572 94.2848 244.138 94.2848Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 99.4084C237.779 99.4084 238.241 98.9466 238.241 98.3773C238.241 97.808 237.779 97.3462 237.21 97.3462C236.64 97.3462 236.179 97.8111 236.179 98.3773C236.179 98.9434 236.64 99.4084 237.21 99.4084Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 99.4084C241.245 99.4084 241.707 98.9466 241.707 98.3773C241.707 97.808 241.245 97.3462 240.676 97.3462C240.106 97.3462 239.645 97.8111 239.645 98.3773C239.645 98.9434 240.106 99.4084 240.676 99.4084Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 99.4084C244.708 99.4084 245.169 98.9466 245.169 98.3773C245.169 97.808 244.708 97.3462 244.138 97.3462C243.569 97.3462 243.107 97.8111 243.107 98.3773C243.107 98.9434 243.572 99.4084 244.138 99.4084Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 104.532C237.779 104.532 238.241 104.071 238.241 103.501C238.241 102.932 237.779 102.47 237.21 102.47C236.64 102.47 236.179 102.932 236.179 103.501C236.179 104.071 236.64 104.532 237.21 104.532Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 104.532C241.245 104.532 241.707 104.071 241.707 103.501C241.707 102.932 241.245 102.47 240.676 102.47C240.106 102.47 239.645 102.932 239.645 103.501C239.645 104.071 240.106 104.532 240.676 104.532Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 104.532C244.708 104.532 245.169 104.071 245.169 103.501C245.169 102.932 244.708 102.47 244.138 102.47C243.569 102.47 243.107 102.932 243.107 103.501C243.107 104.071 243.572 104.532 244.138 104.532Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 109.659C237.779 109.659 238.241 109.198 238.241 108.628C238.241 108.059 237.779 107.597 237.21 107.597C236.64 107.597 236.179 108.059 236.179 108.628C236.179 109.198 236.64 109.659 237.21 109.659Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 109.659C241.245 109.659 241.707 109.198 241.707 108.628C241.707 108.059 241.245 107.597 240.676 107.597C240.106 107.597 239.645 108.059 239.645 108.628C239.645 109.198 240.106 109.659 240.676 109.659Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 109.659C244.708 109.659 245.169 109.198 245.169 108.628C245.169 108.059 244.708 107.597 244.138 107.597C243.569 107.597 243.107 108.059 243.107 108.628C243.107 109.198 243.572 109.659 244.138 109.659Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 114.783C237.779 114.783 238.241 114.322 238.241 113.752C238.241 113.183 237.779 112.721 237.21 112.721C236.64 112.721 236.179 113.186 236.179 113.752C236.179 114.318 236.64 114.783 237.21 114.783Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 114.783C241.245 114.783 241.707 114.322 241.707 113.752C241.707 113.183 241.245 112.721 240.676 112.721C240.106 112.721 239.645 113.186 239.645 113.752C239.645 114.318 240.106 114.783 240.676 114.783Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 114.783C244.708 114.783 245.169 114.322 245.169 113.752C245.169 113.183 244.708 112.721 244.138 112.721C243.569 112.721 243.107 113.186 243.107 113.752C243.107 114.318 243.572 114.783 244.138 114.783Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 119.91C237.779 119.91 238.241 119.449 238.241 118.879C238.241 118.31 237.779 117.848 237.21 117.848C236.64 117.848 236.179 118.313 236.179 118.879C236.179 119.445 236.64 119.91 237.21 119.91Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 119.91C241.245 119.91 241.707 119.449 241.707 118.879C241.707 118.31 241.245 117.848 240.676 117.848C240.106 117.848 239.645 118.313 239.645 118.879C239.645 119.445 240.106 119.91 240.676 119.91Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 119.91C244.708 119.91 245.169 119.449 245.169 118.879C245.169 118.31 244.708 117.848 244.138 117.848C243.569 117.848 243.107 118.313 243.107 118.879C243.107 119.445 243.572 119.91 244.138 119.91Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.21 125.034C237.779 125.034 238.241 124.572 238.241 124.003C238.241 123.433 237.779 122.972 237.21 122.972C236.64 122.972 236.179 123.433 236.179 124.003C236.179 124.572 236.64 125.034 237.21 125.034Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.676 125.034C241.245 125.034 241.707 124.572 241.707 124.003C241.707 123.433 241.245 122.972 240.676 122.972C240.106 122.972 239.645 123.433 239.645 124.003C239.645 124.572 240.106 125.034 240.676 125.034Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.138 125.034C244.708 125.034 245.169 124.572 245.169 124.003C245.169 123.433 244.708 122.972 244.138 122.972C243.569 122.972 243.107 123.433 243.107 124.003C243.107 124.572 243.572 125.034 244.138 125.034Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.428 126.002H233.921V128.377H247.428V126.002Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1 128.374H235.249V129.342H246.1V128.374Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.658 75.4533H237.693V13.9231C237.693 10.2005 239.221 6.80989 241.678 4.34603L241.684 4.3397L241.691 4.33338C243.702 2.32497 246.33 0.939636 249.256 0.5V6.58533C247.965 6.93957 246.814 7.62274 245.9 8.53997L245.887 8.55262C244.515 9.9253 243.661 11.8262 243.661 13.9231V75.4564L243.658 75.4533Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.8 18.9175C240.28 18.9175 240.676 19.3097 240.676 19.7936V75.4534H238.927V19.7936C238.927 19.3128 239.319 18.9175 239.803 18.9175H239.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.495 43.4644C256.643 44.758 261.864 49.4611 277.004 49.2587C277.004 49.2587 278.322 49.9008 278.389 50.9572C278.322 52.0135 277.004 52.6556 277.004 52.6556C261.864 52.4532 256.643 57.1563 255.495 58.4499V52.2318L255.628 50.9572L255.495 49.6825V43.4644Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.233 58.7249C257.7 58.7249 259.711 55.2363 259.711 50.9569C259.711 46.6776 257.7 43.189 255.233 43.189C252.766 43.189 250.755 46.6808 250.755 50.9569C250.755 55.2331 252.766 58.7249 255.233 58.7249Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.96 56.8526C257.832 56.8526 259.36 54.2021 259.36 50.9539C259.36 47.7056 257.832 45.0552 255.96 45.0552C254.088 45.0552 252.561 47.7056 252.561 50.9539C252.561 54.2021 254.088 56.8526 255.96 56.8526Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.213 54.9673C258.488 54.9673 259.525 53.1644 259.525 50.9536C259.525 48.7428 258.488 46.9399 257.213 46.9399C255.939 46.9399 254.901 48.7428 254.901 50.9536C254.901 53.1644 255.939 54.9673 257.213 54.9673Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.92 115.185L135.727 116.434L140.531 117.684L145.338 116.434L150.145 115.185L145.338 113.932L140.531 112.683L135.727 113.932L130.92 115.185Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.053 115.185L142.792 115.773L140.531 116.358L138.273 115.773L136.012 115.185L138.273 114.593L140.531 114.008L142.792 114.593L145.053 115.185Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.409 163.868L213.244 165.313L214.079 166.759H210.742L211.577 165.313L212.412 163.868H212.409ZM243.778 163.868L244.613 165.313L245.448 166.759H242.111L242.946 165.313L243.781 163.868H243.778ZM237.504 163.868L238.338 165.313L239.173 166.759H235.837L236.672 165.313L237.507 163.868H237.504ZM231.229 163.868L232.064 165.313L232.899 166.759H229.562L230.397 165.313L231.232 163.868H231.229ZM224.958 163.868L225.793 165.313L226.628 166.759H223.291L224.126 165.313L224.961 163.868H224.958ZM218.683 163.868L219.518 165.313L220.353 166.759H217.017L217.852 165.313L218.686 163.868H218.683Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.607 168.773L215.442 170.219L216.277 171.661H212.94L213.775 170.219L214.61 168.773H214.607ZM245.976 168.773L246.811 170.219L247.646 171.661H244.31L245.145 170.219L245.979 168.773H245.976ZM239.705 168.773L240.54 170.219L241.375 171.661H238.038L238.873 170.219L239.708 168.773H239.705ZM233.43 168.773L234.265 170.219L235.1 171.661H231.764L232.599 170.219L233.434 168.773H233.43ZM227.156 168.773L227.991 170.219L228.826 171.661H225.489L226.324 170.219L227.159 168.773H227.156ZM220.882 168.773L221.716 170.219L222.551 171.661H219.215L220.05 170.219L220.885 168.773H220.882Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.936 74.5898H286.362C287.513 74.5898 288.56 75.0611 289.319 75.8202C290.078 76.5824 290.549 77.6293 290.549 78.7806V113.499C290.549 114.651 290.078 115.697 289.319 116.457C288.56 117.219 287.513 117.69 286.362 117.69H268.936C267.785 117.69 266.738 117.219 265.979 116.46C265.22 115.697 264.749 114.651 264.749 113.499V78.7806C264.749 77.6293 265.22 76.5824 265.979 75.8234C266.738 75.0611 267.785 74.5898 268.936 74.5898ZM286.362 75.836H268.936C268.127 75.836 267.39 76.1681 266.858 76.6995C266.327 77.2371 265.995 77.9709 265.995 78.7806V113.499C265.995 114.309 266.324 115.043 266.858 115.577C267.393 116.112 268.127 116.441 268.936 116.441H286.362C287.171 116.441 287.908 116.112 288.44 115.577C288.971 115.04 289.303 114.306 289.303 113.496V78.7775C289.303 77.9678 288.974 77.234 288.44 76.6995C287.905 76.1649 287.171 75.8328 286.362 75.8328V75.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.936 122.548H286.362C288.658 122.548 290.552 124.443 290.552 126.739V134.15C290.552 136.446 288.658 138.34 286.362 138.34H268.936C266.64 138.34 264.746 136.446 264.746 134.15V126.739C264.746 124.452 266.65 122.548 268.936 122.548ZM286.362 123.798H268.936C267.327 123.798 265.992 125.132 265.992 126.742V134.153C265.992 135.763 267.327 137.097 268.936 137.097H286.362C287.143 137.097 287.893 136.781 288.443 136.231C288.974 135.696 289.306 134.963 289.306 134.153V126.742C289.306 125.964 288.99 125.211 288.44 124.661C287.905 124.13 287.172 123.798 286.362 123.798Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.852 55.7521C297.816 55.7521 299.42 54.1485 299.42 52.1844C299.42 50.2203 297.816 48.6167 295.852 48.6167C293.889 48.6167 292.285 50.2203 292.285 52.1844C292.285 54.1485 293.889 55.7521 295.852 55.7521Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.967 55.4388C296.444 55.4388 297.645 53.9776 297.645 52.1843C297.645 50.3909 296.444 48.9297 294.967 48.9297C293.49 48.9297 292.288 50.3941 292.288 52.1843C292.288 53.9744 293.49 55.4388 294.967 55.4388Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.091 54.1955C295.001 54.1955 295.745 53.2941 295.745 52.1839C295.745 51.0738 295.001 50.1724 294.091 50.1724C293.18 50.1724 292.437 51.0738 292.437 52.1839C292.437 53.2941 293.18 54.1955 294.091 54.1955Z",
    fill: "#FFDD1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.378 129.117H182.4C182.881 129.117 183.273 129.509 183.273 129.99C183.273 130.471 182.881 130.863 182.4 130.863H166.378C165.901 130.863 165.509 130.471 165.509 129.99C165.509 129.509 165.901 129.117 166.378 129.117Z",
    fill: "#9A0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.378 132.726H182.4C182.881 132.726 183.273 133.118 183.273 133.599C183.273 134.08 182.881 134.472 182.4 134.472H166.378C165.901 134.472 165.509 134.08 165.509 133.599C165.509 133.118 165.901 132.726 166.378 132.726Z",
    fill: "#9A0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.305 150.166H346.791V154.015H374.305V150.166Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.812 150.166H346.791V154.015H357.812V150.166Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1321 87.7317C62.5812 87.7317 58.6407 90.341 56.7242 94.1459C56.4332 94.0384 56.117 93.9815 55.7881 93.9815C54.6843 93.9815 53.7356 94.633 53.2991 95.5724C53.2137 95.5661 53.1315 95.5629 53.0461 95.5629C51.8096 95.5629 50.7122 96.148 50.0133 97.0589C49.1625 95.3763 47.42 94.2218 45.4055 94.2218C44.112 94.2218 42.926 94.6994 42.0215 95.4901C41.7527 95.2593 41.4017 95.1201 41.019 95.1201C40.4561 95.1201 39.9627 95.4206 39.6939 95.8697C39.3176 95.74 38.9128 95.6704 38.4953 95.6704C36.4492 95.6704 34.7888 97.3309 34.7888 99.3773H83.5171C83.5171 96.7616 81.3951 94.6425 78.7828 94.6425C78.4539 94.6425 78.1314 94.6773 77.8214 94.7406C76.0283 90.613 71.917 87.7285 67.1321 87.7285V87.7317ZM24.9913 98.0394C24.2513 98.0394 23.6504 98.6404 23.6504 99.3805H30.6364C30.6364 98.0489 29.5548 96.9672 28.2234 96.9672C27.2082 96.9672 26.3417 97.5934 25.9843 98.479C25.7377 98.2102 25.3835 98.0394 24.9913 98.0394Z",
    fill: "#C9DBF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.258 88.0096C343.151 88.0096 346.472 90.4608 347.762 93.9083C347.948 93.8735 348.138 93.8577 348.334 93.8577C349.046 93.8577 349.704 94.0886 350.238 94.4776C351.035 92.8235 352.569 91.5899 354.409 91.1978C354.438 89.7049 355.659 88.503 357.158 88.503C358.075 88.503 358.888 88.9521 359.387 89.6448C361.462 87.2758 364.504 85.7798 367.901 85.7798C373.344 85.7798 377.888 89.6258 378.97 94.7496C379.732 94.0253 380.763 93.5794 381.898 93.5794C382.898 93.5794 383.815 93.9241 384.539 94.4998C385.896 90.7992 389.45 88.1551 393.622 88.1551C396.278 88.1551 398.685 89.2273 400.434 90.9637C400.984 90.5747 401.655 90.3469 402.379 90.3469C403.777 90.3469 404.972 91.1946 405.484 92.406H405.636C407.714 92.406 409.479 93.7565 410.092 95.6321C410.725 93.4307 412.755 91.8177 415.162 91.8177C417.568 91.8177 419.634 93.456 420.247 95.689C420.715 94.9457 421.544 94.4492 422.489 94.4492C423.95 94.4492 425.133 95.6321 425.133 97.0933H318.062C318.062 96.1381 318.837 95.3664 319.789 95.3664C319.969 95.3664 320.14 95.3917 320.302 95.4423C320.827 94.68 321.709 94.1772 322.705 94.1772C322.901 94.1772 323.091 94.1961 323.274 94.2341C324.397 91.5298 327.063 89.6258 330.172 89.6258C331.266 89.6258 332.307 89.8599 333.243 90.2837C334.843 88.8699 336.946 88.0096 339.248 88.0096H339.258Z",
    fill: "#C9DBF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7948_25403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 223,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTruck);
export default __webpack_public_path__ + "static/media/big-truck.dd3bfe04c00f210702d8945714170c6e.svg";
export { ForwardRef as ReactComponent };